import imageCompression from "browser-image-compression";

const compressedFileOptions = {
  maxSizeMB: 5,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
}

export const getEditorConfiguration = (ref) => {
  return {
    min_height: 500,
    skin: "oxide-dark",
    content_css: "dark",
    plugins: "table advlist lists image media link autoresize code",
    toolbar: "undo redo | styles | fontfamily fontsize bold italic underline forecolor backcolor| alignleft aligncenter alignright alignjustify | bullist numlist | link image media | table code",
    contextmenu: 'false',
    browser_spellcheck: true,
    branding: false,
    menubar: false,
    image_title: true,
    automatic_uploads: true,
    file_picker_types: 'image',
    file_picker_callback: (callback, _value, _meta) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'file');
      input.setAttribute('accept', 'image/*');
      input.addEventListener('change', async (e) => {
        const file = (e.target as HTMLInputElement).files[0];
        const compressedFile = await imageCompression(file, compressedFileOptions);

        const reader = new FileReader();
        reader.addEventListener('load', () => {
          const id = 'blobid' + (new Date()).getTime();
          const blobCache = ref.current.editorUpload.blobCache;
          const base64 = (reader.result as string).split(',')[1];
          const blobInfo = blobCache.create(id, compressedFile, base64);
          blobCache.add(blobInfo);
          callback(blobInfo.blobUri(), { title: compressedFile.name });
        });
        reader.readAsDataURL(compressedFile);
      });

      input.click();
    },
  };
};
